import { createContextHook } from '@/utils';
import { MagicPromptContext } from '../MagicPromptContext';

export const useMagicPrompt = createContextHook(MagicPromptContext);
